import { render } from "./ForexAlertsTable.vue?vue&type=template&id=85f9f0ee&ts=true"
import script from "./ForexAlertsTable.vue?vue&type=script&lang=ts"
export * from "./ForexAlertsTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__